module.exports = __webpack_public_path__ + "static/media/vote-yea.bbaec922.svg";